module.exports = __webpack_public_path__ + "resources/img/img_edb_2_en.f37d43e54c5f0550ee4cda387001b0bb.png";